import * as React from 'react';

/**
 *
 * IspSerpSorting component
 * @extends {React.PureComponent<IIspSerpProps<IIspSerpData>>}
 */
class IspSortOPtion extends React.Component <IAppProps, IAppState> {
    /* tslint:disable:no-string-literal */
    public handleOnClick = (event: React.MouseEvent<HTMLElement>) => {
        if (window['ispHandleSortingChoice'] !== undefined) {
            window['ispHandleSortingChoice'](event.currentTarget.dataset.arg);
        }
      }
    /* tslint:enable:no-string-literal */

    public render(): JSX.Element | null {
        return (
                <li role='presentation' style={{listStyle: 'none'}}>
                    <a
                        id={this.props.id}
                        data-arg={this.props.id}
                        style={{paddingLeft: '24px'}}
                        role='menuitem'
                        title={this.props.title}
                        aria-label={this.props.label}
                        onClick={this.handleOnClick}
                    >
                        {this.props.text}
                    </a>
                </li>
        );
    }
}

interface IAppProps {
    id: string;
    title: string;
    label: string;
    text: string;
}

interface IAppState {
    name: string;
}

export default IspSortOPtion;